import { render, staticRenderFns } from "./TechnologyOtherTerms .vue?vue&type=template&id=0e68be50&scoped=true"
import script from "./TechnologyOtherTerms .vue?vue&type=script&lang=js"
export * from "./TechnologyOtherTerms .vue?vue&type=script&lang=js"
import style0 from "./TechnologyOtherTerms .vue?vue&type=style&index=0&id=0e68be50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e68be50",
  null
  
)

export default component.exports